import { axios } from "../middleware";

import { AlvysConnection, AlvysConnectionUpdate } from "models/Alvys";

//get alvys connection
export const getAlvysConnectionAPI = async () => {
  return axios.get<AlvysConnection>(`/factoring/profiles/alvys/`);
};

//update alvys connection
export const updateAlvysConnectionAPI = async (data: AlvysConnectionUpdate) => {
  return axios.put<AlvysConnection>(`/factoring/profiles/alvys/`, data);
};

//remove alvys connection
export const removeAlvysConnectionAPI = async () => {
  return axios.delete<AlvysConnection>(`/factoring/profiles/alvys/`);
};
